import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import "./public-story.css";
import "./sales-journey.css";
import { post } from "./lib/api";

async function clientEvent(event_name: string, metadata: Record<string, unknown> = {}) {
  await post("/api/events", { event_name, ...metadata });
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).then(registration => {
      void clientEvent("pwa_service_worker_ready", { scope: registration.scope }).catch(() => undefined);
    }).catch(() => undefined);
  });
}

createRoot(document.getElementById("root")!).render(<React.StrictMode><App /></React.StrictMode>);
